var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.808,
    height: 11.38,
    viewBox: "0 0 14.808 11.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2767",
    "data-name": "Group 2767",
    transform: "translate(0 -95.292)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    "data-name": "Path 869",
    d: "M5.011,267.194a2.388,2.388,0,0,1,.839-1.817,3.033,3.033,0,0,0-1.927-.689H3.047A3.051,3.051,0,0,0,0,267.735v3.434H4.554A2.889,2.889,0,0,1,5.966,269.1,2.39,2.39,0,0,1,5.011,267.194Z",
    transform: "translate(0 -164.497)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_870",
    "data-name": "Path 870",
    d: "M189.888,434.052a2.02,2.02,0,0,0-1.969,1.583h3.938A2.02,2.02,0,0,0,189.888,434.052Z",
    transform: "translate(-182.484 -328.962)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    "data-name": "Path 871",
    d: "M308.633,298.561h-.876a3.028,3.028,0,0,0-1.4.343,2.388,2.388,0,0,1-.64,3.094,2.889,2.889,0,0,1,1.412,2.064h4.554v-2.454A3.051,3.051,0,0,0,308.633,298.561Z",
    transform: "translate(-296.872 -197.39)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_535",
    "data-name": "Ellipse 535",
    cx: 2.016,
    cy: 2.016,
    r: 2.016,
    transform: "matrix(0.995, -0.099, 0.099, 0.995, 9.119, 96.476)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_536",
    "data-name": "Ellipse 536",
    cx: 2.016,
    cy: 2.016,
    r: 2.016,
    transform: "translate(1.471 95.292)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_872",
    "data-name": "Path 872",
    d: "M204.761,298.561a1.526,1.526,0,1,0,1.526,1.526A1.528,1.528,0,0,0,204.761,298.561Z",
    transform: "translate(-197.357 -197.39)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParents);
export default __webpack_public_path__ + "static/media/Parents.b10987482df4e16d9341ac7d57dbf1aa.svg";
export { ForwardRef as ReactComponent };